export default function Stepper(theme) {
  return {
    MuiStepper: {
      styleOverrides: {
        root: {
          padding: theme.spacing(3, 0),
        },
      },
    },
    MuiStep: {
      styleOverrides: {
        root: {
          '& .MuiStepLabel-root': {
            '& .MuiStepLabel-label': {
              fontWeight: 500,
              '&.Mui-active': {
                fontWeight: 600,
              },
              '&.Mui-completed': {
                fontWeight: 500,
              },
            },
          },
        },
      },
    },
    MuiStepLabel: {
      styleOverrides: {
        root: {
          '& .MuiStepLabel-iconContainer': {
            '& .MuiSvgIcon-root': {
              fontSize: '1.75rem',
            },
          },
        },
      },
    },
    MuiStepContent: {
      styleOverrides: {
        root: {
          borderLeft: `2px solid ${theme.palette.divider}`,
          paddingLeft: theme.spacing(3),
          marginLeft: theme.spacing(2.5),
        },
      },
    },
  };
}

